import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';
import { useMatchBreakpoint } from '@hivebrite/design-system/Theme';

import GoBackNavigation from 'hb-react/frontoffice/components/GoBackNavigation';
import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

interface LayoutProps {
  children: React.ReactNode;
  goToUrl?: string;
  dataTestId?: string;
  goBackLabel?: string;
}

const Layout = ({
  children,
  goToUrl,
  dataTestId,
  goBackLabel,
}: LayoutProps) => {
  const isMobile: boolean = useMatchBreakpoint(['s']);

  return (
    <Container>
      <Grid width="100%" mx={isMobile ? 0 : undefined}>
        <Row>
          <Col
            offset={{
              _: 0,
              l: 2 / 12,
              xl: 3 / 12,
            }}
            width={{ _: 1, l: 8 / 12, xl: 6 / 12 }}
          >
            <Box
              display="block"
              mt={{ _: 0, m: 6 }}
              mb={{ _: 0, m: 18 }}
              data-testid={dataTestId}
            >
              {goToUrl && (
                <GoBackNavigation url={goToUrl} mx={0}>
                  {goBackLabel}
                </GoBackNavigation>
              )}
              {children}
            </Box>
          </Col>
        </Row>
      </Grid>
    </Container>
  );
};

export default Layout;
